import React, { useEffect, useRef } from "react";
import L from "leaflet";

import ParqueMarinoElArenal from './geoJson/ParqueMarinoElArenal.json';
import ParqueMarinoElPalillo from './geoJson/ParqueMarinoElPalillo.json';
import ParqueMarinoLoberia from './geoJson/ParqueMarinoLoberia.json';
import ParqueMarinoMontesSUbmarinosCruseoYSelkirk from './geoJson/ParqueMarinoMontesSubmarinosCruseoYSelKirk.json';
import ParqueMarinoMotuMotiroHiva from './geoJson/ParqueMarinoMotuMotiroHiva.json';
import ParqueMarinoNazcaDesventurada from './geoJson/ParqueMarinoNazcaDesventurada.json';
import ParqueMarinoTierraBlanca from './geoJson/ParqueMarinoTierraBlanca.json';
import ReservaMarinaIslasChanaral from './geoJson/ReservaMarinaIslaCHanaral.json';
import ReserveMarinaIslasChoros from './geoJson/ReservaMarinaIslasChorosYDamas.json';
import ReservaMarinaLaRinconada from './geoJson/ReservaMarinaLaRinconadaDN.json';
import ReservaMarinaPetemun from './geoJson/ReservaMarinaPetemun.json';
import ReservaMarinaPulliquen from './geoJson/ReservaMarinaPullinque.json';
import AmerbDamasDecretoExento from './geoJson/AmerbDamasDecretoExento.json';
import FranciscoColane from './geoJson/FranciscoColane.json';
import JuanFernandez from './geoJson/JuanFernandez.json';
import IslasDiegoRamirez from './geoJson/islas_diego_ramirez.json';
import LeafletGlobo from './LeafletIcons/LeafletGlobo.svg';

/**
 * Componente de mapa para renderizado de zonas de parques y reservas marinas
 *
 */


const style = {
  height: "100%",
  width: "100%"
};


function LeafletMap({ markerPosition, zoom, zoomConmutator, dynamicPopup }) {
  // create map
  const mapRef = useRef(null);
  var popup = L.popup();

  const customIcon = L.icon({
    iconUrl: LeafletGlobo,
    iconSize: [35, 45],
    iconAnchor: [17, 45],
  });

  useEffect(() => {
    let effectMap = L.map("map", {
      center: markerPosition != null ? [markerPosition.lat, markerPosition.lng] : [-33.439269, -70.646881],
      zoom: zoom,
      dragging: !L.Browser.mobile,
      tap: !L.Browser.mobile,
      layers: [
        L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        })
      ]
    });

    effectMap.on("click", onMapClick);

    mapRef.current = effectMap;
    /**
     * Carga de polígonos
     *
     */

    var geoJsonLayer = L.geoJSON().addTo(effectMap);

    {
      geoJsonLayer.addData(ParqueMarinoElArenal);


      let marker = L.marker(ParqueMarinoElArenal.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoElArenal.name + "</b><br><span>" + ParqueMarinoElArenal.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoElPalillo);
      let marker = L.marker(ParqueMarinoElPalillo.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoElPalillo.name + "</b><br><span>" + ParqueMarinoElPalillo.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoLoberia);
      let marker = L.marker(ParqueMarinoLoberia.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoLoberia.name + "</b><br><span>" + ParqueMarinoLoberia.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoMontesSUbmarinosCruseoYSelkirk);
      let marker = L.marker(ParqueMarinoMontesSUbmarinosCruseoYSelkirk.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoMontesSUbmarinosCruseoYSelkirk.name + "</b><br><span>" + ParqueMarinoMontesSUbmarinosCruseoYSelkirk.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoMotuMotiroHiva);
      let marker = L.marker(ParqueMarinoMotuMotiroHiva.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoMotuMotiroHiva.name + "</b><br><span>" + ParqueMarinoMotuMotiroHiva.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoNazcaDesventurada);
      let marker = L.marker(ParqueMarinoNazcaDesventurada.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoNazcaDesventurada.name + "</b><br><span>" + ParqueMarinoNazcaDesventurada.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ParqueMarinoTierraBlanca);
      let marker = L.marker(ParqueMarinoTierraBlanca.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ParqueMarinoTierraBlanca.name + "</b><br><span>" + ParqueMarinoTierraBlanca.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(AmerbDamasDecretoExento);
      let marker = L.marker(AmerbDamasDecretoExento.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + AmerbDamasDecretoExento.name + "</b><br><span>" + AmerbDamasDecretoExento.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(FranciscoColane);
      let marker = L.marker(FranciscoColane.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + FranciscoColane.name + "</b><br><span>" + FranciscoColane.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(JuanFernandez);
      let marker = L.marker(JuanFernandez.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + JuanFernandez.name + "</b><br><span>" + JuanFernandez.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ReservaMarinaPetemun);
      let marker = L.marker(ReservaMarinaPetemun.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ReservaMarinaPetemun.name + "</b><br><span>" + ReservaMarinaPetemun.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ReservaMarinaPulliquen);
      let marker = L.marker(ReservaMarinaPulliquen.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ReservaMarinaPulliquen.name + "</b><br><span>" + ReservaMarinaPulliquen.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ReservaMarinaLaRinconada);
      let marker = L.marker(ReservaMarinaLaRinconada.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ReservaMarinaLaRinconada.name + "</b><br><span>" + ReservaMarinaLaRinconada.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ReservaMarinaIslasChanaral);
      let marker = L.marker(ReservaMarinaIslasChanaral.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ReservaMarinaIslasChanaral.name + "</b><br><span>" + ReservaMarinaIslasChanaral.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(ReserveMarinaIslasChoros);
      let marker = L.marker(ReserveMarinaIslasChoros.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + ReserveMarinaIslasChoros.name + "</b><br><span>" + ReserveMarinaIslasChoros.legend + "</span>");//.openPopup();
    }

    {
      geoJsonLayer.addData(IslasDiegoRamirez);
      let marker = L.marker(IslasDiegoRamirez.markerPosition, { icon: customIcon }).addTo(effectMap);
      marker.bindPopup("<b>" + IslasDiegoRamirez.name + "</b><br><span>" + IslasDiegoRamirez.legend + "</span>");//.openPopup();
    }


  }, []);

  function onMapClick(e) {
    popup
      .setLatLng(e.latlng)
      .setContent(e.latlng.toString())
      .openOn(mapRef.current);
  }

  // add marker
  const markerRef = useRef(null);
  useEffect(
    () => {

      if (markerPosition != null) {
        setTimeout(() => {



          if (markerRef.current) {
            markerRef.current.setLatLng(markerPosition);
            if (markerPosition.legend != null) {
              markerRef.current.bindPopup("<b>" + markerPosition.legend + "</b>").openPopup();
            }
          } else {
            let marker = L.marker(markerPosition).addTo(mapRef.current);
            if (markerPosition.legend != null) {
              marker.bindPopup("<b>" + markerPosition.legend + "</b>").openPopup();
            }
            markerRef.current = marker;
          }

          mapRef.current.panTo(new L.latLng(markerPosition.lat, markerPosition.lng));
        }, 100);
      }



    },
    [markerPosition]
  );

  useEffect(() => {
    if (markerPosition != null) {
      mapRef.current.setZoom(zoom);
      mapRef.current.panTo(new L.latLng(markerPosition.lat, markerPosition.lng));
    }
  }, [zoomConmutator]);

  useEffect(() => {
    if (dynamicPopup != null) {
      popup
        .setLatLng([dynamicPopup.markerPosition[0], dynamicPopup.markerPosition[1]])
        .setContent("<b>" + dynamicPopup.name + "</b><br><div>" + dynamicPopup.legend + "</div>")
        .openOn(mapRef.current);

        mapRef.current.setZoom(6);

        setTimeout(() => {
          mapRef.current.panTo(new L.latLng(dynamicPopup.markerPosition[0], dynamicPopup.markerPosition[1]));
        }, 300);
    }
  }, [dynamicPopup])


  return <div id="map" style={style} />;
}

export default LeafletMap;